import Component from "../../components/Menu/Menu";
import {useEffect, useState, useRef} from "preact/hooks";
import {createPortal} from "preact/compat/dist/compat";
import tippy from "tippy.js";

const Menu = ({ isVisible, options, children, onClickOutside, onClick, tippyOpts }) => {
  const dropdown = useRef(null);
  const [tippyInstance, setTippyInstance] = useState(null);

  useEffect(() => {
    const instance = tippy(dropdown.current, {
      trigger: 'manual',
      interactive: true,
      placement: 'bottom-end',
      hideOnClick: 'toggle',
      offset: [0, -7],
      appendTo: document.body,
      render() {
        return { popper: document.createElement("div") };
      },
      onClickOutside: (instance) => {
        instance.__isVisible && onClickOutside && onClickOutside();
      },
      ...tippyOpts
    });
    setTippyInstance(instance);
  }, []);

  const show = () => {
    tippyInstance && tippyInstance.show();
  };

  const hide = () => {
    tippyInstance && tippyInstance.hide();
  };

  useEffect(() => {
    if (tippyInstance) {
      isVisible ? show() : hide();
      tippyInstance.__isVisible = isVisible;
    }
  }, [isVisible]);

  return <div ref={dropdown} onClick={onClick}>
    {children}
    {tippyInstance && createPortal(<Component isVisible={isVisible} options={options} />, tippyInstance.popper)}
  </div>;
};

export default Menu;



// WEBPACK FOOTER //
// ./containers/Menu/Menu.js